import { colors } from '@atlaskit/theme';
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';
import React from 'react';
import Tooltip from 'components/common/Tooltip';
import { FormattedMessage } from 'react-intl';
import { messages } from 'modules/mac/messages';
import { StyledDivWithTextAlign } from '../../styledComponents';

export const TechnicalTooltip: React.FC = () => (
  <Tooltip
    direction="up-middle"
    content={
      <StyledDivWithTextAlign $textAlign="center">
        <p>
          <FormattedMessage {...messages.tooltipLine1} />
        </p>
        <p>
          <FormattedMessage {...messages.tooltipLine2} />
        </p>
        <p>
          <FormattedMessage {...messages.tooltipLine3} />
        </p>
      </StyledDivWithTextAlign>
    }
  >
    <QuestionCircleIcon size="small" primaryColor={colors.N80} label="help" />
  </Tooltip>
);
